const pl = {
  common: {
    wallet: "portfel",
    playPage: "graj",
    minTop: "minimalna kwota to 10$",
    maxTop: "maks kwota to 500$",
    website: "strona internetowa",
    signOut: "wyloguj się",
    hidden: "ukryte",
    victory: "wygrana",
    wentWrong: "coś poszło nie tak, przekierowuję",
    stakeLabel: "stawka",
    howDoes: "jak to działa?",
    continue: "Kontynuuj",
    continueWithGoogle: "Kontynuuj z Google",
    continueWithApple: "Kontynuuj z Apple",
    termsOfService: "warunki użytkowania",
    privacyPolicy: "politykę prywatności",
    termsOfServiceFooter: "warunki użytkowania",
    privacyPolicyFooter: "polityka prywatności",
    verificationCode: "kod weryfikacyjny",
    verify: "zweryfikuj",
    account: "konto",
    error: "wystąpił błąd\n",
    checkBackLater: "sprawdź ponownie później",
    looking: "szukam...",
    yes: "tak",
    no: "nie",
    pleaseSelect: "Proszę wybrać\n",
    disclaimer: "kontynuując zgadzasz się na nasze\n",
    and: "i",
  },
  endOfGame: {
    wonByCheckmate: "wygrana przez szach mat",
    lostOnTime: "przegrana na czas",
    resigns: "poddaje się",
    gameDrawnByAgreement: "remis za porozumieniem",
    abandonedTheGame: "porzucił grę",
    gameAborted: "gra przerwana",
    gameDrawnByStalemate: "remis przez pat",
    gameDrawnByFiftyMoveRule: "remis przez 50 posunięć",
    gameDrawnByInsufficientMaterial: "remis z powodu niewystarczającego materiału",
    gameDrawnByThreefoldRepetition: "remis przez trzykrotne powtórzenie",
    draw: "remis",
    victory: "wygrana",
    defeat: "porażka",
    aborted: "przerwano",
    white: "białe",
    black: "czarne",
    inspectBoard: "zobacz planszę",
    returnToEndOfGameModal: "kontynuować",
  },
  byPhone: {
    continueOnPhone: "kontynuuj na\ntelefonie",
    or: "lub",
    continueOnWeb: "kontynuuj w\nprzeglądarce",
    disclaimer: "odpowiednie, jeśli masz zdjęcie swojego dowodu osobistego na dysku"
  },
  signUp: {
    email: "email",
    username: "nazwa użytkownika",
    usernameInvalid: "nieprawidłowa nazwa użytkownika",
    emailInvalid: "nieprawidłowy email",
    login: "zaloguj się",
    continueWithPhone: "kontynuuj z numerem telefonu",
    tickBoxes: "zaznaczmy kilka\npól",
    confirm: "Potwierdzam, że\n",
    resideIn: "Mieszkam w\n",
    notPEP: "Nie jestem osobą politycznie narażoną (PEP), członkiem rodziny ani znanym współpracownikiem PEP\n",
    purpose: "Celem i naturą mojej relacji z Gambit jest wyłącznie korzystanie z usługi dla rozrywki\n",
    soleBenefit: "Będę korzystać z usługi wyłącznie na moją korzyść i nie ma innego właściciela korzyści\n",
  },
  identity: {
    beingVerified: "tożsamość\njest weryfikowana",
    verified: "zweryfikowano\n",
    failed: "weryfikacja\nnie powiodła się",
  },
  payment: {
    failed: "płatność nie powiodła się.\nproszę spróbować ponownie",
    successful: "płatność\nzakończona sukcesem!",
    toppedUp: "doładowałeś\nswoje konto!",
    topUp: "doładuj\n",
    payWith: "zapłać za pomocą...\n",
  },
  gameplay: {
    play: "zagraj\n",
    challenge: "wyzwania na",
    gameWorth: "gra warta\n",
    whatsYourNumber: "jaki jest twój\nnumer?",
    receiveCode: "wkrótce otrzymasz kod\nweryfikacyjny",
    matchedOpponent: "Zostaniesz sparowany z przeciwnikiem o podobnym rankingu.",
    stake: {
      total: "Całkowita stawka będzie równa wybranej poniżej kwocie.",
      contribution: "Przyczynisz się do niej mniej więcej połową tej kwoty.",
      weakerOpponent: "Jeśli zostaniesz sparowany ze słabszym przeciwnikiem, zapłacisz większą część stawki.",
      strongerOpponent: "Jeśli zostaniesz sparowany z silniejszym przeciwnikiem, zapłacisz mniejszą część stawki.",
    },
    supportInfo: "Odwiedź nasze wsparcie, aby uzyskać więcej informacji.\n",
    continueBrowser: "kontynuuj w\nprzeglądarce",
    continuePhone: "kontynuuj na\ntelefonie",
    getStarted: "zaczynajmy\n",
    sentText: "wysłaliśmy ci\nSMS",
    enterReceivedCode: "wprowadź otrzymany\nkod weryfikacyjny",
    wrongCode: "zły kod, spróbuj ponownie\n",
    secPerMove: "sek/ruch",
    resign: {
      prompt: "czy na pewno chcesz się poddać?",
    },
    draw: {
      offer: "akceptować ofertę remisu?",
    },
    rating: "ranking\n",
    balance: "saldo\n",
    rematch: "rewanż\n",
    newOpponent: "nowy przeciwnik\n",
    home: "strona główna\n",
    rematchOffer: "twój przeciwnik proponuje rewanż. akceptujesz?",
    leaveGame: "Obecnie grasz w grę. Czy na pewno chcesz wyjść?",
    room: "pokój:\n",
    gameTypes: {
      bullet: {
        title: "bullet\n",
        description: "Szachy z adrenaliną. Ty i twój przeciwnik macie tylko 1 minutę, aby wygrać grę.",
      },
      blitz: {
        title: "blitz\n",
        description: "Ty i twój przeciwnik macie po 3 minuty na wygranie gry.",
      },
    },
    stakes: {
      unlockNext: "rozegraj {amount} więcej gier, aby odblokować następną stawkę",
      allUnlocked: "odblokowałeś wszystkie stawki",
    },
    withdraw: "wypłać\n",
  },
  puzzle: {
    begin: "rozpocznij",
    next: "następny",
    unavailableInYourRegion: "niedostępne",
    puzzle: "układanka",
    whiteToPlay: "biały na ruchu",
    blackToPlay: "czarny na ruchu",
    time: "czas",
    solution: "rozwiązanie",
    somethingWentWrong: "coś poszło nie tak",
    rating: "ocena",
    credits: "kredyty",
    puzzleFailed: "porażka",
    puzzleSolved: "zwycięstwo",
    correct: "prawidłowe rozwiązanie",
    incorrect: "nieprawidłowe rozwiązanie",
    youRanOutOfTime: "skończył ci się czas",
    puzzleDescription: "Masz 10 sekund + 2 sekundy/ruch na rozwiązanie układanki.",
    creditsLeft: "pozostałe kredyty",
    refillIn: "uzupełnij za",
    lastPuzzle: "to twoja ostatnia zagadka, wróć później po więcej.",
    outOfCredits: "skończyły ci się kredyty, wróć później.",
    locationPrompt: "Potrzebujemy Twojej lokalizacji, aby kontynuować. Jeśli jest zablokowana, włącz ją ponownie:",
    locationInstructions: "Kliknij ikonę w pasku adresu, wybierz 'Zawsze zezwalaj' i odśwież stronę",
    creditsError: "Błąd podczas ładowania kredytów",
    moves: "Ruchy:",
  },
};

export {pl};